import { StatusIcon } from '@/components/sv/status-icon'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { BackupStatus } from '@/graphql.types'
import type { FC } from 'react'

const tooltipMap: Record<BackupStatus, string> = {
  creating: 'Backup is being created',
  deleting: 'Backup is being deleted',
  ready: 'Backup is ready',
}

type Props = {
  status?: BackupStatus
}

export const BackupStatusIcon: FC<Props> = ({ status }) => {
  if (!status) {
    return null
  }
  const tooltip = tooltipMap[status]
  return (
    <Tooltip>
      <TooltipTrigger asChild className="cursor-pointer">
        <div>
          <StatusIcon status={status} />
        </div>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  )
}
